<ng-container>
  <div class="row">
    @for (option of options; track option) {
      <div
        class="col-md-6 mt"
        [ngClass]="{
          'pointer-events': form.get(option.formControlName).disabled,
        }"
      >
        @if (form.get(option.formControlName).disabled) {
          <div class="disabled-icon"></div>
        }
        <pr-input-checkbox
          [derrors]="derrors"
          [formControlName]="option.formControlName"
          label=""
          [withBox]="true"
        >
          <residence-box
            [suffix]="option.suffix"
            [title]="option.label"
            [svg]="option.svg"
          ></residence-box>
        </pr-input-checkbox>
      </div>
    }
  </div>

  @if (form.get('avOptionInvestissementProgressif').value) {
    <info [option]="{ icon: 'info' }">
      L'investissement progressif ou programmé est une option qui permet à
      l'assuré d'injecter son capital dans des unités de compte (UC) à un rythme
      régulier, en tenant compte des performances des fonds de placement qui
      l'intéressent.
    </info>
  }

  @if (form.get('avOptionSecurisationPlusValues').value) {
    <info [option]="{ icon: 'info' }">
      la sécurisation des plus-values est une clause qui consiste à arbitrer
      automatiquement les plus-values des supports sélectionnés vers un fonds
      euros. Cela permet de mettre à l'abri les intérêts réalisés en les plaçant
      sur un fonds à capital garanti, bien que potentiellement moins
      rémunérateur.
    </info>
  }

  @if (form.get('avOptionLimitationMoinsValuesRelatives').value) {
    <info [option]="{ icon: 'info' }">
      La limitation de la moins-value, aussi appelée « Stop Loss » est une
      clause que peut ajouter le souscripteur pour éviter une trop grande perte
      en capital. Cette clause permet un arbitrage automatique des fonds
      investis sur un support vers un autre support, lorsque le premier nommé
      atteint un seuil critique définit par le souscripteur. La limitation des
      moins-values peut-être relative, c'est le cas lorsque le seuil de
      moins-value est atteint, non pas par rapport à la valeur initiale de
      l'investissement, mais en fonction du plus haut niveau atteint par les
      fonds.
    </info>
  }

  @if (form.get('avOptionReequilibrageAutomatique').value) {
    <info [option]="{ icon: 'info' }">
      Le service de rééquilibrage automatique des investissements évalue
      régulièrement l'écart entre la composition courante du compte du
      participant et la répartition d'origine, puis rajuste cette composition
      pour la ramener à sa pondération initiale.
    </info>
  }
</ng-container>
